module.exports = __webpack_public_path__ + "img/qbert_questions_p15.070aae73.jpg";